import { FeatureFlagStoreType } from './types'

import { DEFAULT_FLAGS } from '@/constants/feature-flag'
import { createReactStore } from '@/utils/create-react-store'

export const FeatureFlagStore = createReactStore<FeatureFlagStoreType>(() => ({
  flags: DEFAULT_FLAGS,
}))
